import { useState, useCallback } from 'react';
import { submitForm } from '@/api/forms';

export function useFormSubmit(formType: string) {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = useCallback(async (data: Record<string, unknown>) => {
    setLoading(true);
    setError(null);
    try {
      await submitForm(formType, data);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 4000);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setLoading(false);
    }
  }, [formType]);

  return { submit, loading, success, error };
}
